export const BLOG_SLICE = "blog";
